import start from '../../../../common/microservices/loaders/order-calculator/with-price-table'

import '../lazy-microservices/lazy-microservices'

start(() => import('../order-calculator/render'), 'microservice__new-order__root', {
  lazyStoreManagerLoader: () => import('../../../../common/microservices/lazy-store-manager'),

  priceTableRenderLoader: () => import('./render'),
  priceTableRenderMountPointId: 'microservice__prices-table__root',

  mediaQuery: '(min-width: 768px)',
})
